// extracted by mini-css-extract-plugin
export default {"notifications-header-container":"Notifications_notifications-header-container__ATsNa","notification-switch-text":"Notifications_notification-switch-text__6tYXX"};